<template>
  <PdfViewer v-if="pdfUrl" :key="pdfUrl" :pdfUrl="pdfUrl" />
</template>

<script>
import PdfViewer from '../Shared/PdfViewer.vue'
export default {
  components: {
    PdfViewer
  },
  props: {
    pluviometricChartData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    pdfUrl () {
      return this.pluviometricChartData && 
        this.pluviometricChartData.file && 
        this.pluviometricChartData.file.url 
        ? this.pluviometricChartData.file.url 
        : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// PluviometricChart.vue?8a1070f8